var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_714_785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3649 21.7262C33.3649 21.723 33.3623 21.7205 33.3591 21.7205H26.0679C25.854 21.7205 25.6806 21.5471 25.6806 21.3332C25.6806 21.137 25.8278 20.9731 26.021 20.9388C28.6977 20.4631 30.7313 18.2133 30.7313 15.5188C30.7313 12.4765 28.141 10 24.959 10C21.7771 10 19.1868 12.4765 19.1868 15.5188C19.1868 18.2133 21.2204 20.4631 23.8971 20.9388C24.0903 20.9731 24.2375 21.137 24.2375 21.3332C24.2375 21.5471 24.0641 21.7205 23.8502 21.7205H8.2971C7.89578 21.7205 7.53333 21.9604 7.37656 22.3298L2.59011 33.6094C2.31027 34.2688 2.79428 35 3.51066 35H37.489C38.2055 35 38.6895 34.2687 38.4095 33.6092L33.3653 21.7284C33.365 21.7277 33.3649 21.727 33.3649 21.7262ZM20.6299 15.5188C20.6299 13.2354 22.5708 11.3797 24.959 11.3797C27.3473 11.3797 29.2882 13.2354 29.2882 15.5188C29.2882 17.1718 28.2691 18.5958 26.8029 19.2582C26.2414 19.5119 25.6806 19.0367 25.6806 18.4205V16.5438C25.6806 16.1453 25.3575 15.8223 24.959 15.8223C24.5606 15.8223 24.2375 16.1453 24.2375 16.5438V18.4205C24.2375 19.0367 23.6767 19.5119 23.1152 19.2582C21.649 18.5958 20.6299 17.1718 20.6299 15.5188ZM8.35049 23.7092C8.50735 23.3399 8.8697 23.1002 9.27088 23.1002H23.2375C23.7898 23.1002 24.2375 23.5479 24.2375 24.1002V25.1449C24.2375 25.5434 24.5606 25.8664 24.959 25.8664C25.3575 25.8664 25.6806 25.5434 25.6806 25.1449V24.1002C25.6806 23.5479 26.1283 23.1002 26.6806 23.1002H31.7363C32.1375 23.1002 32.4999 23.3399 32.6567 23.7092L36.2733 32.2224C36.5535 32.8819 36.0695 33.6134 35.353 33.6134H5.65426C4.93771 33.6134 4.4537 32.8819 4.73387 32.2224L8.35049 23.7092Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_714_785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 27,
    fill: "white",
    transform: "translate(1 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandIconWhite);
export default __webpack_public_path__ + "static/media/landIconWhite.6bf06389b8cd2a8b7bd44184144739dc.svg";
export { ForwardRef as ReactComponent };